(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.directive('websiteGeneratorLink', ['WebsiteGeneratorService', WebsiteGeneratorLinkFn]);

    // filter directive for multiple shared agenda selection
    function WebsiteGeneratorLinkFn(WebsiteGeneratorService) {
        
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/website-generator/templates/website-generator-link.template.html',
            scope: {
                url: '=',
                copylink:'&',
                header:'='
            }
            
        };
        return directive;
        function link(scope, element, attrs) {
            scope.filterCollapsed = false;
            scope.urlSoloDisplay = '';        
            scope.WebsiteGeneratorService = WebsiteGeneratorService;
        } // link
    }
})();